import Section from "../Section";
import Parallax from '../global/Parallax';
import KenBurns from '../global/KenBurns';

export default class ImageWithTextOverlay extends Section {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.kenBurns = new KenBurns(theme, element);
    this.parallax = new Parallax(theme, element);
  }

  onSectionSelect = () => {
    this.kenBurns.reapply();
  }
}
